import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { Logger, OrganizationService } from 'src/app/@shared';
import { OfferAsset, OfferAssetsService } from 'src/app/modules/standard/v1';
import * as dayjs from 'dayjs';

const log = new Logger('OfferAssetCardsComponent');

@Component({
  selector: 'app-offer-asset-cards',
  templateUrl: './offer-asset-cards.component.html',
  styleUrls: ['./offer-asset-cards.component.scss']
})

export class OfferAssetCardsComponent implements OnInit {

  viewModel$ = combineLatest([
    this.offerAssetService.assets$,
    this.offerAssetService.isLoading$,
    this.offerAssetService.totalRecords$,
    this.offerAssetService.page$,
    this.offerAssetService.offerId$,
    this.organizationService.assetsUrl$
  ]).pipe(
    map(([assets, isLoading, totalRecords, page, offerId, assetsUrl]) => {
      if (assets.length == 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0
        page.pageIndex = 0
        this.offerAssetService.page(page);
        this.offerAssetService.reload();
      }
      assets.forEach(asset => asset.DateAdded = dayjs(asset.DateAdded).format('MM/DD/YYYY'));
      return { assets, isLoading, totalRecords, page, offerId, assetsUrl }
    }),
  );
  assetsList: OfferAsset[] = [];
  selection = new SelectionModel<OfferAsset>(true, []);
  assetsUrl$: Observable<string> = this.organizationService.assetsUrl$;
  constructor(private offerAssetService: OfferAssetsService<OfferAsset>,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private matSnackBar: MatSnackBar, private organizationService: OrganizationService) { }

  ngOnInit(): void {
    log.debug('init');
    // get the offer id from the parent route
    this.offerAssetService.offerId = this.route.snapshot.params['offerId'];
  }

  onSort(sortState: Sort): void {
    this.offerAssetService.sort(sortState);
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.offerAssetService.page(pageEvent);
  }

  onSearch(event: any) {
    this.offerAssetService.search(event.target.value);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assetsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assetsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }

  public getImageSrc(assetsUrl: any, assets: any) {
    let imagesrc = '';
    if (assets.Type === 'application/pdf') {
      imagesrc = './assets/images/pdf.png';
    } else if (assets.Type.indexOf('audio') > -1) {
      imagesrc = './assets/images/mp3.jpg';
    } else if (assets.Type.indexOf('video') > -1) {
      imagesrc = './assets/images/mp4.png';
    } else if (assets.Type.indexOf('text') > -1) {
      imagesrc = './assets/images/text.png';
    }
    else {
      imagesrc = assetsUrl + '/' + assets.Detail.FileName;
    }
    return imagesrc;
  }

}
